import type { SalespersonOption } from '@/features/order/service-order-form.types.ts'

export function formatSalespersonOption(option: SalespersonOption): SalespersonOption {
  return option.isDisable && !option.label.endsWith('（已停用）')
    ? { ...option, label: `${option.label}（已停用）` }
    : option
}
